import React, { useState } from "react"
import { isFieldError } from "../../utils/"
import { Container } from "./styled"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSquare, faCheckSquare } from "@fortawesome/pro-light-svg-icons"

const CheckboxOrder = ({ name, label, reqd, update, errors }) => {
  const [checked, setChecked] = useState(false)

  const handleClick = name => {
    setChecked(!checked)
    update(name, !checked)
  }

  return (
    <Container className={isFieldError(errors, name) ? `error` : ``}>
      <button type="button" onClick={e => handleClick(name)}>
        <div>
          <FontAwesomeIcon icon={checked ? faCheckSquare : faSquare} />
        </div>
      </button>
    </Container>
  )
}
export default CheckboxOrder
